import React from 'react';
import '../assets/Shops.css';
import '../App.css';
import { useData } from '../context/DataContext';

const PlusIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
       strokeWidth="2.2" strokeLinecap="round">
    <line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

const PinIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
       strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" /><circle cx="12" cy="10" r="3" />
  </svg>
);

export const ListStores: React.FC<{ onAdd: () => void }> = ({ onAdd }) => {
  const { stores, storesLoading: loading, storesError: error } = useData();

  return (
    <>
      <div className="store-toolbar">
        <button className="btn btn--primary btn--sm" onClick={onAdd}>
          <PlusIcon /> Add shop
        </button>
      </div>

      {loading && stores.length === 0 ? (
        <div className="stores-list">
          {[0, 1, 2].map(i => <div key={i} className="skeleton" style={{ height: 108 }} />)}
        </div>
      ) : error ? (
        <div className="state state--error">
          <p className="state__title">Couldn’t load shops</p>
          <p className="state__body">{error}</p>
        </div>
      ) : stores.length === 0 ? (
        <div className="state">
          <p className="state__title">No shops yet</p>
          <p className="state__body">Add your first shop to start taking orders.</p>
          <button className="btn btn--primary" onClick={onAdd}>Add shop</button>
        </div>
      ) : (
        <div className="stores-list">
          {stores.map(store => {
            const located = store.latitude != null && store.longitude != null;
            return (
              <div className="store-card" key={store.id || store.phone}>
                <div className="store-card__top">
                  <div className="store-avatar">{store.name?.[0] || 'S'}</div>
                  <div className="store-info">
                    <p className="store-name">{store.name}</p>
                    <p className="store-phone mono">{store.phone}</p>
                  </div>
                </div>

                <div className="store-card__tags">
                  {store.product_type && (
                    <span className="chip chip--brand">{store.product_type}</span>
                  )}
                  {/* Coordinates are only ever useful as "set / not set" here;
                      six decimal places on a card is noise. */}
                  <span className={`chip ${located ? 'chip--ok' : 'chip--warn'}`}>
                    <PinIcon />
                    {located ? 'Location set' : 'No location'}
                  </span>
                </div>

                {store.cr_number && (
                  <dl className="store-card__meta">
                    <dt>CR number</dt>
                    <dd className="mono">{store.cr_number}</dd>
                  </dl>
                )}
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};
